
module.exports = name => `
import React from 'react'
import renderer from 'react-test-renderer'

import ${name} from './${name}.jsx'
import { taskIndent } from 'constants'

test("component renders", () => {
    const tree = renderer.create(<${name} />).toJSON()
    expect(tree).toMatchSnapshot()
})

`



// WEBPACK FOOTER //
// ./src/templates/component_test.js